import { RatingsEnum } from './skills.enums';

export const RatingScoreMapping = {
  [RatingsEnum.NOVICE]: 1,
  [RatingsEnum.INTERMEDIATE]: 2,
  [RatingsEnum.ADVANCED]: 3,
  [RatingsEnum.EXPERT]: 4,
};
